import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { AutocompleteComponent, CheckboxComponent, SelectComponent, SubmitGroupComponent } from '@libs/form/components';
import { AutocompleteInputModel, CheckboxInputModel, SelectInputModel, SubmitGroupItemModel } from '@libs/form/models';
import { firstValueFrom } from 'rxjs';
import { DebuggerPageState } from '../debugger.model';
import { bffEnvConfig, pageRootConfig, showNavigationConfig, submitConfig } from './page-debugger.model';
import { PageDebuggerService } from './page-debugger.service';

@Component({
  selector: 'ui-page-debugger',
  styleUrls: ['./page-debugger.component.scss'],
  templateUrl: './page-debugger.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatCardModule,
    ReactiveFormsModule,
    SelectComponent,
    AutocompleteComponent,
    SubmitGroupComponent,
    CheckboxComponent,
  ],
})
export class PageDebuggerComponent {
  public readonly pageState: Signal<DebuggerPageState | undefined>;
  public readonly bffEnvConfig: Signal<SelectInputModel>;
  public readonly pageRootConfig: Signal<AutocompleteInputModel>;
  public readonly showNavigationConfig: Signal<CheckboxInputModel>;
  public readonly submitConfig: SubmitGroupItemModel = submitConfig;
  public readonly form: FormGroup<Record<'bffEnv' | 'pageId' | 'showNav', FormControl>>;

  public constructor(
    private readonly service: PageDebuggerService,
  ) {
    this.pageState = toSignal(this.service.getPageState());
    this.bffEnvConfig = computed(() => ({ ...bffEnvConfig, value: this.pageState()?.bffEnv }));
    this.pageRootConfig = computed(() => ({ ...pageRootConfig, value: this.pageState()?.pageId }));
    this.showNavigationConfig = computed(() => ({ ...showNavigationConfig, value: this.pageState()?.showNav }));
    this.submitConfig = submitConfig;

    this.form = new FormGroup({
      bffEnv: new FormControl(),
      pageId: new FormControl(),
      showNav: new FormControl(),
    });
  }

  public onShowNavigationChange(showNavigation: boolean): void {
    this.service.updateNavigationVisibility(showNavigation);
  }

  public async onSubmit(): Promise<void> {
    if (!this.form.valid) {
      return;
    }

    await firstValueFrom(
      this.service.updatePageState(this.form.value as Omit<DebuggerPageState, 'page'>),
    );
  }
}
